import React, { Component } from 'react';
import style from './style.css';
import CSSModules from 'react-css-modules';

import ApplyCard from './applyCard'; 
import SimpleCard from './simpleCard';
import Button from '../button';

class ClassBar extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }

        this.onClick = (e) => {
            if( this.props.onClick) this.props.onClick();
            if(this.props.type === 'full' || this.props.type === 'simple') this.setState({ open: !this.state.open});
            else {
                /* api */
            }
        }
    }
    renderBar( type ) {
        if( type === 'full' ) return <ApplyCard />;
        else return <SimpleCard />;
    }
    render(){

        const { content, type } = this.props;
        //console.log(this.state.open);
        return (
            <div styleName="block" className={ this.props.className}>
                <Button  onClick={this.onClick} styleName="barButton">{ content }</Button>
                { this.state.open && this.renderBar(type, content) }
            </div>
        );
    }
}

export default CSSModules(ClassBar,style,{allowMultiple:true});


/** WEBPACK FOOTER **
 ** ./src/component/classBar/index.js
 **/